import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';
import { getMetalTypeDetailValue } from '@/features/pdp/utils/getMetalTypeDetailValue';

interface PdpDesktopMetalDetailsProps {
  goldPurity: string | null;
  metal: string;
  metalType: string;
  shortDesc?: string | null;
  metalWeight: number;
  onInfoIconClick?: (label: string) => void;
}

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

export function PdpDesktopMetalDetails({
  goldPurity,
  metal,
  metalType,
  shortDesc,
  metalWeight,
  onInfoIconClick,
}: PdpDesktopMetalDetailsProps) {
  const typeValue = getMetalTypeDetailValue(goldPurity, metal, metalType, shortDesc);

  return (
    <>
      {typeValue ? <PdpDesktopDetailRow label="Type" value={typeValue} /> : null}
      {metalWeight > 0 ? (
        <PdpDesktopDetailRow
          label="Weight"
          value={`${metalWeight} gram`}
          tooltip={WEIGHT_VARIATION_TEXT}
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
    </>
  );
}
